import PropTypes from 'prop-types';
import { Inline, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { Check } from '@phosphor-icons/react';
import { useTranslation } from '@eti/providers';

const symbolBlockStyles = (isCurrent, isEmphasized) => css`
  align-items: center;
  background-color: ${isEmphasized ? vars.colors.decoration.primary : '#d9d9d9'};
  border: 4px solid ${isCurrent ? vars.colors.decoration.secondary : '#fff'};
  border-radius: 50%;
  color: ${isEmphasized ? '#fff' : '#000'};
  display: flex;
  flex-shrink: 0;
  font-size: 0.625rem;
  height: 28px;
  justify-content: center;
  width: 28px;
`;

const labelStyles = (isCurrent, isEmphasized) => css`
  color: ${isEmphasized ? 'inherit' : '#737373'};
  font-weight: ${isCurrent ? '700' : '400'};
`;

const Step = ({ className, id, isCurrent, isVisited, label }) => {
  const { t } = useTranslation();
  const hasVisited = isVisited ? 'visited' : 'not-visited';
  const stepType = isCurrent ? 'current' : hasVisited;
  const arialLabelText = `${label}${
    isVisited ? `, ${t('ScreenReader.StepIndicator.Step.Complete.Text')}` : ''
  }`;

  return (
    <Inline
      alignY="center"
      aria-current={isCurrent ? 'step' : undefined}
      aria-label={arialLabelText}
      as="li"
      className={className}
      data-testid={`${stepType}-step`}
      noWrap
      spacing={8}
    >
      <div aria-hidden className={symbolBlockStyles(isCurrent, isCurrent || isVisited)}>
        {isVisited ? <Check size="14" weight="bold" /> : id}
      </div>
      <span aria-hidden className={labelStyles(isCurrent, isCurrent || isVisited)}>
        {label}
      </span>
    </Inline>
  );
};

Step.propTypes = {
  className: PropTypes.string,
  id: PropTypes.number,
  isCurrent: PropTypes.bool,
  isVisited: PropTypes.bool,
  label: PropTypes.string,
};

export default Step;
